import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const AnalyticsTracker = () => {
  const location = useLocation();

  useEffect(() => {
    if (window.gtag) {
      window.gtag('config', 'G-HFSL6V18P6', {
        page_path: location.pathname + location.search,
      });
    }
  }, [location]);

  return null; // This component does not render anything
};

export default AnalyticsTracker; 